<template>
	<!-- 详情 -->
	<div>
		<div class="pd20" style="background: #ffffff;">
			<div v-if="detailData" class="detail_bg">
				<div class="detail_title">
					<div class="detail_title_d">{{ detailData.title }}</div>
				</div>
				<div class="d_sub_t">
					<div class="d_sub_tk">
						<div>开始时间：{{ detailData.startTime }}</div>
					</div>
					<div class="d_sub_tk">
						<div>
							结束时间：{{ detailData.endTime }}
						</div>
					</div>
				</div>
				<div class="content_bg">
					<div class="title">内容：</div>
					<div class="cb_c">{{ detailData.content }}</div>
				</div>

				<div class="file_bg">
					<div class="title">附件：</div>
					<div>
						<!-- <fileImage  :fileData="detailData.filePath"></fileImage> -->
						<div class="pre_bg">
							<div class="pre_item" v-for="(item) in fileList" :key="item.keyId"
								@click="preItemClick(item)">
								<div class="pre_img">
									<span>{{ item.fileType }}</span>
								</div>
								<div class="pre_name">{{ item.name }}</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
		<el-dialog title="图片预览" :visible.sync="dialogVisible" width="37.5rem" append-to-body >
			<img class="big_img" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>

</template>

<script>
import {
	GetSystemNoticeDetail
} from '../../../api/systemApi.js';
import fileImage from "@/components/fileImage.vue";
export default {
	props: {
		param: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			detailData: null,
			fileList: [],
			dialogVisible: false,
			dialogImageUrl: '',
		};
	},
	computed: {},
	components: {
		fileImage
	},
	created() {
		this.GetSystemNoticeDetailData(this.param.row.keyId);
	},
	mounted() { },
	methods: {
		// 根据keyId获取通知详细
		GetSystemNoticeDetailData(key) {
			let params = {
				keyId: key
			};
			GetSystemNoticeDetail(params)
				.then((res) => {
					if (res.code === 1) {
						this.detailData = res.data;
						if (res.data.filePath && res.data.filePath.length > 0) {
							this.fileList = JSON.parse(res.data.filePath)
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error('加载数据失败，请稍后再试！');
				});
		},

		// 文件点击
		preItemClick(file) {
			if (file.fileType === '.png' || file.fileType === '.jpg') {
				this.dialogImageUrl = localStorage.getItem('filePath') + file.url
				this.dialogVisible = true;
			} else {
				let fullDownloadUrl = '/api/sysConfig/DownLoad/DownLoadFile?fileName=' +
					encodeURIComponent(file.url)
				let temp = file.url.split("/");
				let fileInfoName = temp.pop();
				this.$preloadWeb.fileDownLoad({
					fullDownloadUrl,
					fileInfoName
				});
			}
		},

	},

};
</script>
<style scoped lang="scss">
.detail_bg {
	width: 800px;
	margin: 0 auto;
	overflow-y: auto;
}

.detail_title {
	width: 100%;
	height: 60px;
	display: flex;
	align-items: center;
}

.detail_title_d {
	font-size: 26px;
	font-weight: 600;
}

.d_sub_t {
	width: 100%;
	margin-bottom: 15px;
}

.d_sub_tk {
	width: 80%;
	height: 100%;
	display: flex;
	align-items: center;
	margin-top: 15px;
}

.content_bg {
	width: 100%;
	display: flex;


	.title {
		width: 80px;

	}

	.cb_c {
		width: 720px;
		height: 500px;
		line-height: 2;
		overflow-y: auto;
		color: #767676;
	}
}

.file_bg {
	width: 100%;
	display: flex;
	margin-top: 15px;

	.title {
		width: 80px;

	}
}

.pre_bg {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 20px;
}

.pre_item {
	width: 80px;
	height: 80px;
	margin-bottom: 20px;

	.pre_img {
		width: 60px;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #55aaff;
		color: #55aaff;
		border-radius: 10px;
		position: relative;
		cursor: pointer;

		.pre_delete {
			position: absolute;
			top: 0px;
			right: 0px;
			color: #ff0000;
			font-size: 18px;
		}

	}

	.pre_name {
		width: 70px;
		font-size: 12px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

}

.big_img {
	width: 100%;
}
</style>